/**
 * tdesign v1.1.1
 * (c) 2023 tdesign
 * @license MIT
 */

import { _ as _defineProperty } from '../_chunks/dep-b011b919.mjs';
import { defineComponent, toRefs, inject, ref, computed, onMounted, createVNode } from 'vue';
import props from './menu-item-props.mjs';
import { renderTNodeJSX, renderContent } from '../utils/render-tnode.mjs';
import { emitEvent } from '../utils/event.mjs';
import useRipple from '../hooks/useRipple.mjs';
import { usePrefixClass } from '../hooks/useConfig.mjs';
import '../_chunks/dep-ae1abe1d.mjs';
import '../_chunks/dep-ff1c0573.mjs';
import '../_chunks/dep-eba62589.mjs';
import '../_chunks/dep-42be3824.mjs';
import '../_chunks/dep-a11a63ea.mjs';
import '../_chunks/dep-7d9e11c8.mjs';
import '../_chunks/dep-750294df.mjs';
import '../_chunks/dep-a6022780.mjs';
import '../_chunks/dep-ad1accf9.mjs';
import '../_chunks/dep-a255de71.mjs';
import '../_chunks/dep-8d19eb1a.mjs';
import '../_chunks/dep-16e2f1a5.mjs';
import '../_chunks/dep-ebe8bc2f.mjs';
import '../_chunks/dep-ebfafd52.mjs';
import '../_chunks/dep-b9567f6a.mjs';
import '../_chunks/dep-654b4b01.mjs';
import '../_chunks/dep-3e3494dc.mjs';
import '../_chunks/dep-7f2f03b4.mjs';
import '../_chunks/dep-f50ac97c.mjs';
import '../_chunks/dep-94585de3.mjs';
import '../_chunks/dep-06221fe2.mjs';
import '../_chunks/dep-d7053a2c.mjs';
import '../_chunks/dep-f3e3393e.mjs';
import '../_chunks/dep-0fa7026c.mjs';
import '../_chunks/dep-31dc9d09.mjs';
import '../_chunks/dep-b9d74a58.mjs';
import '../utils/helper.mjs';
import '../_chunks/dep-c3626417.mjs';
import '../_chunks/dep-fc63c737.mjs';
import '../_chunks/dep-2a2a0e63.mjs';
import '../_chunks/dep-fdde96c5.mjs';
import '../_chunks/dep-e00db566.mjs';
import '../_chunks/dep-961339ce.mjs';
import '../hooks/useKeepAnimation.mjs';
import '../_chunks/dep-a0bd2e3a.mjs';
import '../_chunks/dep-2b8d75e2.mjs';
import '../_chunks/dep-8f44163a.mjs';
import '../_chunks/dep-cc371884.mjs';
import '../_chunks/dep-1f0070bb.mjs';
import '../_chunks/dep-9d0d32fd.mjs';
import '../_chunks/dep-e05e20e6.mjs';
import '../_chunks/dep-91208ac3.mjs';
import '../_chunks/dep-1041f7d7.mjs';
import '../_chunks/dep-b32fb318.mjs';
import '../_chunks/dep-9b57842b.mjs';
import '../_common/js/global-config/default-config.mjs';
import '../_common/js/global-config/locale/zh_CN.mjs';
import '../_chunks/dep-99a0abba.mjs';
import '../_chunks/dep-9d5ee0e1.mjs';
import '../config-provider/useConfig.mjs';
import '../_chunks/dep-adebe2ce.mjs';
import '../_chunks/dep-bd3d75f1.mjs';
import '../_chunks/dep-67dfe9c7.mjs';
import '../config-provider/type.mjs';
import '../utils/set-style.mjs';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var _MenuItem = defineComponent({
  name: "TMenuItem",
  props: _objectSpread({}, props),
  emits: ["click"],
  setup: function setup(props2, ctx) {
    var _toRefs = toRefs(props2),
      href = _toRefs.href,
      _toRefs$target = _toRefs.target,
      target = _toRefs$target === void 0 ? "_self" : _toRefs$target;
    var classPrefix = usePrefixClass();
    var menu = inject("TdMenu");
    var itemRef = ref();
    useRipple(itemRef);
    var submenu = inject("TdSubmenu", null);
    var active = computed(function () {
      return menu.activeValue.value === props2.value;
    });
    var classes = computed(function () {
      var _ref;
      return ["".concat(classPrefix.value, "-menu__item"), (_ref = {}, _defineProperty(_ref, "".concat(classPrefix.value, "-is-active"), active.value), _defineProperty(_ref, "".concat(classPrefix.value, "-is-disabled"), props2.disabled), _defineProperty(_ref, "".concat(classPrefix.value, "-menu__item--plain"), !ctx.slots.icon && !props2.icon), _defineProperty(_ref, "".concat(classPrefix.value, "-submenu__item"), !!submenu && !menu.isHead), _ref)];
    });
    onMounted(function () {
      var _menu$vMenu;
      menu === null || menu === void 0 ? void 0 : (_menu$vMenu = menu.vMenu) === null || _menu$vMenu === void 0 ? void 0 : _menu$vMenu.add({
        value: props2.value,
        parent: submenu === null || submenu === void 0 ? void 0 : submenu.value,
        vnode: ctx.slots["default"]
      });
    });
    return {
      classPrefix: classPrefix,
      menu: menu,
      active: active,
      classes: classes,
      itemRef: itemRef,
      href: href,
      target: target
    };
  },
  methods: {
    handleClick: function handleClick(e) {
      e.stopPropagation();
      if (this.disabled) return;
      this.menu.select(this.value);
      emitEvent(this, "click");
      if (this.to) {
        var router = this.router || this.$router;
        var methods = this.replace ? "replace" : "push";
        router[methods](this.to)["catch"](function (err) {
          if (err.name !== "NavigationDuplicated" && !err.message.includes("Avoided redundant navigation to current location")) {
            throw err;
          }
        });
      }
    }
  },
  render: function render() {
    return createVNode("li", {
      "ref": "itemRef",
      "class": this.classes,
      "onClick": this.handleClick
    }, [renderTNodeJSX(this, "icon"), this.href ? createVNode("a", {
      "href": this.href,
      "target": this.target,
      "className": "".concat(this.classPrefix, "-menu__item-link")
    }, [createVNode("span", {
      "className": "".concat(this.classPrefix, "-menu__content")
    }, [renderContent(this, "default", "content")])]) : createVNode("span", {
      "class": ["".concat(this.classPrefix, "-menu__content")]
    }, [renderContent(this, "default", "content")])]);
  }
});

export { _MenuItem as default };
//# sourceMappingURL=menu-item.mjs.map
